/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectDataSubscription } from './ProjectDataSubscription';
import {
    ProjectDataSubscriptionFromJSON,
    ProjectDataSubscriptionFromJSONTyped,
    ProjectDataSubscriptionToJSON,
    ProjectDataSubscriptionToJSONTyped,
} from './ProjectDataSubscription';
import type { ProjectPermission } from './ProjectPermission';
import {
    ProjectPermissionFromJSON,
    ProjectPermissionFromJSONTyped,
    ProjectPermissionToJSON,
    ProjectPermissionToJSONTyped,
} from './ProjectPermission';
import type { ProjectDataBillingAccount } from './ProjectDataBillingAccount';
import {
    ProjectDataBillingAccountFromJSON,
    ProjectDataBillingAccountFromJSONTyped,
    ProjectDataBillingAccountToJSON,
    ProjectDataBillingAccountToJSONTyped,
} from './ProjectDataBillingAccount';

/**
 * 
 * @export
 * @interface ProjectDataWithPermissions
 */
export interface ProjectDataWithPermissions {
    /**
     * 
     * @type {string}
     * @memberof ProjectDataWithPermissions
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataWithPermissions
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataWithPermissions
     */
    logoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataWithPermissions
     */
    currency?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDataWithPermissions
     */
    hasErpIntegration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDataWithPermissions
     */
    hasLeadIntegration?: boolean;
    /**
     * 
     * @type {ProjectDataBillingAccount}
     * @memberof ProjectDataWithPermissions
     */
    billingAccount?: ProjectDataBillingAccount | null;
    /**
     * 
     * @type {ProjectDataSubscription}
     * @memberof ProjectDataWithPermissions
     */
    subscription?: ProjectDataSubscription | null;
    /**
     * 
     * @type {Array<ProjectPermission>}
     * @memberof ProjectDataWithPermissions
     */
    permissions?: Array<ProjectPermission>;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDataWithPermissions
     */
    isOwner?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectDataWithPermissions
     */
    forbiddenChannels?: Array<string>;
}

/**
 * Check if a given object implements the ProjectDataWithPermissions interface.
 */
export function instanceOfProjectDataWithPermissions(value: object): value is ProjectDataWithPermissions {
    return true;
}

export function ProjectDataWithPermissionsFromJSON(json: any): ProjectDataWithPermissions {
    return ProjectDataWithPermissionsFromJSONTyped(json, false);
}

export function ProjectDataWithPermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDataWithPermissions {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'hasErpIntegration': json['hasErpIntegration'] == null ? undefined : json['hasErpIntegration'],
        'hasLeadIntegration': json['hasLeadIntegration'] == null ? undefined : json['hasLeadIntegration'],
        'billingAccount': json['billingAccount'] == null ? undefined : ProjectDataBillingAccountFromJSON(json['billingAccount']),
        'subscription': json['subscription'] == null ? undefined : ProjectDataSubscriptionFromJSON(json['subscription']),
        'permissions': json['permissions'] == null ? undefined : ((json['permissions'] as Array<any>).map(ProjectPermissionFromJSON)),
        'isOwner': json['isOwner'] == null ? undefined : json['isOwner'],
        'forbiddenChannels': json['forbiddenChannels'] == null ? undefined : json['forbiddenChannels'],
    };
}

export function ProjectDataWithPermissionsToJSON(json: any): ProjectDataWithPermissions {
    return ProjectDataWithPermissionsToJSONTyped(json, false);
}

export function ProjectDataWithPermissionsToJSONTyped(value?: ProjectDataWithPermissions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'logoUrl': value['logoUrl'],
        'currency': value['currency'],
        'hasErpIntegration': value['hasErpIntegration'],
        'hasLeadIntegration': value['hasLeadIntegration'],
        'billingAccount': ProjectDataBillingAccountToJSON(value['billingAccount']),
        'subscription': ProjectDataSubscriptionToJSON(value['subscription']),
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(ProjectPermissionToJSON)),
        'isOwner': value['isOwner'],
        'forbiddenChannels': value['forbiddenChannels'],
    };
}

